import { createContext, useEffect, useReducer } from "react";

import axios from "../utils/axios";
import SessionHistoryReducer from "../reducers/SessionHistoryReducer";
import { isValidToken, setSession } from "../utils/jwt";
import { SessionHistoryConstants } from "../constants/sessionhistory.constants";
import { saveFile } from "../utils/common";
const initialState = {
  sessionHistories: [],
  sessionHistoryStats: {
    total: 0,
    open: 0,
    confirmed: 0,
    interested: 0,
    notInterested: 0,
    closed: 0,
  },
  paging: {
    totalNumberOfRecords: 0,
    totalNumberOfPages: 0,
    pageNumber: 0,
    pageSize: 0,
  },
  paging: {
    totalNumberOfRecords: 0,
    totalNumberOfPages: 0,
    pageNumber: 0,
    pageSize: 0,
  },
  sessionHistoryHistories: [],
  paging: {
    totalNumberOfRecords: 0,
    totalNumberOfPages: 0,
    pageNumber: 0,
    pageSize: 0,
  },
  hasError: false,
  errorMessage: "",
  sessionHistorySearchResults: [],
  sessionHistoryHistorySearchResults: [],
  sessionHistory: {},
  sessionHistoryHistory: {},
  isUpload: false,
  uploadError: false,
  uploadSuccess: false,
  isSubmitting: false,
  isLoadingDownload: false,
  SessionHistoryAutoSearchResults: {
    data: [],
    paging: {
      hasNextPage: false,
      hasPreviousPage: false,
      pageNumber: 0,
      pageSize: 0,
      totalNumberOfPages: 0,
      totalNumberOfRecords: 0,
    },
  },

  autoSearchLoading: false,
  isLoading: true,
  isLoadingAutoSearch: true,
  downloadFileType: "",
};
const initPayload = {
  filters: [],
  pagination: {
    pageNumber: 1,
    pageSize: 100,
  },
  sortFields: [],
};

const SessionHistoryContext = createContext({
  ...initialState,
  getAllSessionHistory: () => {},
  getAllSessionHistoryHistory: () => {},
  getAllStats: () => {},

  addSessionHistory: () => {},
  searchSessionHistory: () => {},
  autoSearchSessionHistory: () => {},
  getSessionHistory: () => {},
  assignSessionHistory: () => {},
  updateSessionHistory: () => {},
  downloadFile: () => {},
  sampleFile: () => {},
  uploadFile: () => {},
});

function SessionHistoryProvider({ children }) {
  const [state, dispatch] = useReducer(SessionHistoryReducer, initialState);

  const getAllSessionHistory = async (payload) => {
    try {
      dispatch({
        type: SessionHistoryConstants.FETCH_SESSION_HISTORY_REQUEST,
      });
      const response = await axios.post("/radius/raduser/session-history", payload);

      dispatch({
        type: SessionHistoryConstants.FETCH_SESSION_HISTORY_SUCCESS,
        payload: response.data,
      });
      return response.data;
    } catch (exception) {
      dispatch({
        type: SessionHistoryConstants.FETCH_SESSION_HISTORY_FAILURE,
      });
    }
  };

  const getAllSessionHistoryHistory = async (payload) => {
    try {
      dispatch({
        type: SessionHistoryConstants.FETCH_SESSION_HISTORY_HISTORY_REQUEST,
      });
      const response = await axios.post("/radius/raduser/session-history/history", payload);

      dispatch({
        type: SessionHistoryConstants.FETCH_SESSION_HISTORY_HISTORY_SUCCESS,
        payload: response.data,
      });
      return response.data;
    } catch (exception) {
      dispatch({
        type: SessionHistoryConstants.FETCH_SESSION_HISTORY_HISTORY_FAILURE,
      });
    }
  };

  const getAllSessionHistoryStats = async (payload) => {
    try {
      const response = await axios.post("/radius/raduser/session-history/stats", payload);
      dispatch({
        type: SessionHistoryConstants.FETCH_SESSION_HISTORY_STATS_REQUEST,
      });
      dispatch({
        type: SessionHistoryConstants.FETCH_SESSION_HISTORY_STATS_SUCCESS,
        payload: response.data,
      });
      return response.data;
    } catch (exception) {
      dispatch({
        type: SessionHistoryConstants.FETCH_SESSION_HISTORY_STATS_FAILURE,
      });
    }
  };

  const searchSessionHistory = async (payload) => {
    try {
      const response = await axios.post("/radius/raduser/session-history/search", payload);
      dispatch({
        type: SessionHistoryConstants.SESSION_HISTORY_SEARCH_REQUEST,
      });
      console.log(response.data, "response.data");
      dispatch({
        type: SessionHistoryConstants.SESSION_HISTORY_SEARCH_SUCCESS,
        payload: response.data,
      });
    } catch (exception) {
      dispatch({
        type: SessionHistoryConstants.SESSION_HISTORY_SEARCH_FAILURE,
      });
    }
  };
  const autoSearchSessionHistory = async (payload) => {
    try {
      const response = await axios.post("/radius/raduser/session-history/auto-search", payload);
      dispatch({
        type: SessionHistoryConstants.SESSION_HISTORY_AUTO_SEARCH_REQUEST,
      });
      console.log(response.data, "response.data");
      dispatch({
        type: SessionHistoryConstants.SESSION_HISTORY_AUTO_SEARCH_SUCCESS,
        payload: response.data,
      });
    } catch (exception) {
      dispatch({
        type: SessionHistoryConstants.SESSION_HISTORY_AUTO_SEARCH_FAILURE,
      });
    }
  };
  const addSessionHistory = async (payload) => {
    const response = await axios.post("/radius/raduser/session-history/add", payload);
    dispatch({
      type: SessionHistoryConstants.ADD_SESSION_HISTORY_REQUEST,
    });
    dispatch({
      type: SessionHistoryConstants.ADD_SESSION_HISTORY_SUCCESS,
      payload: response.data,
    });
  };

  const getSessionHistory = async (id) => {
    const response = await axios.get("/radius/raduser/session-history/" + id);
    dispatch({
      type: SessionHistoryConstants.GET_SESSION_HISTORY_REQUEST,
    });
    dispatch({
      type: SessionHistoryConstants.GET_SESSION_HISTORY_SUCCESS,
      payload: response.data,
    });
  };

  const updateSessionHistory = async (payload) => {
    const response = await axios.put(
      "/radius/raduser/session-history/update/" + payload.sessionHistoryId,
      payload,
    );
    dispatch({
      type: SessionHistoryConstants.UPDATE_SESSION_HISTORY_REQUEST,
    });
    dispatch({
      type: SessionHistoryConstants.UPDATE_SESSION_HISTORY_SUCCESS,
      payload: response.data,
    });
  };

  const assignSessionHistory = async (payload) => {
    const response = await axios.post("/radius/raduser/session-history/assign", payload);
    dispatch({
      type: SessionHistoryConstants.SESSION_HISTORY_ASSIGN_REQUEST,
    });
    dispatch({
      type: SessionHistoryConstants.SESSION_HISTORY_ASSIGN_SUCCESS,
      payload: response.data,
    });
  };

  const downloadFile = async (fileType, payload) => {
    dispatch({
      type: SessionHistoryConstants.DOWNLOAD_SESSION_HISTORY_REQUEST,
      payload: {
        fileType: fileType,
      },
    });
    const response = await axios.post(
      "/radius/raduser/session-history/export/" + fileType,
      payload,
      {
        responseType: "blob",
      },
    );
    console.log(response.headers, "filename");
    //const filename = response.headers.get("content-disposition").split('"');

    await saveFile(response.data, "sessionHistory." + fileType);

    dispatch({
      type: SessionHistoryConstants.DOWNLOAD_SESSION_HISTORY_SUCCESS,
      payload: response.data,
    });
  };

  const sampleFile = async (fileType) => {
    const response = await axios.get("/radius/raduser/session-history/sample/" + fileType, {
      responseType: "blob",
    });

    await saveFile(response.data, "sample_sessionHistory." + fileType);
    dispatch({
      type: SessionHistoryConstants.DOWNLOAD_SESSION_HISTORY_REQUEST,
    });
    dispatch({
      type: SessionHistoryConstants.DOWNLOAD_SESSION_HISTORY_SUCCESS,
      payload: response.data,
    });
  };

  const uploadFile = async (payload) => {
    try {
      dispatch({
        type: SessionHistoryConstants.UPLOAD_SESSION_HISTORY_REQUEST,
      });
      const response = await axios({
        url: "/radius/raduser/session-history/upload",
        method: "POST",
        data: payload,
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      dispatch({
        type: SessionHistoryConstants.UPLOAD_SESSION_HISTORY_SUCCESS,
        payload: response.data,
      });
    } catch (error) {
      console.log("errr", error);
      dispatch({
        type: SessionHistoryConstants.UPLOAD_SESSION_HISTORY_FAILURE,
      });
    }
  };

  return (
    <SessionHistoryContext.Provider
      value={{
        ...state,
        getAllSessionHistory,
        getAllSessionHistoryHistory,
        getAllSessionHistoryStats,
        addSessionHistory,
        searchSessionHistory,
        autoSearchSessionHistory,
        getSessionHistory,
        assignSessionHistory,
        updateSessionHistory,
        downloadFile,
        sampleFile,
        uploadFile,
      }}
    >
      {children}
    </SessionHistoryContext.Provider>
  );
}

export { SessionHistoryContext, SessionHistoryProvider };
